<div class="document-position" [class.b2c-form]="b2cForm">
    <div
        class="position-header"
    >
        <div class="title details-card-title" *ngIf="positionTitle?.length">
            <span class="title--product-type">{{ (position?.index ?? index + 1) + '. ' + getTranslatedProductType() }}&nbsp;</span>
            <ng-container *ngFor="let crumb of positionTitle; index as i">
                <icc-icon name="navigate_next" *ngIf="i > 0"></icc-icon>
                <span *ngIf="i > 0" class="details-card-title__crumb">{{ crumb }}</span>
            </ng-container>
        </div>

        <div
            *ngIf="!preview"
            class="actions"
        >

            <button
                *ngIf="hasAccessTo.movePositions && !b2cForm && !selected"
                iccButton
                (click)="selectPositionEvent()"
                appearance="outline"
            >{{ 'INTERFACE|Wybierz' | translate }}</button>

            <button
                *ngIf="hasAccessTo.movePositions && !b2cForm && selected"
                iccButton
                (click)="selectPositionEvent()"
                appearance="secondary"
            ><icc-icon name="done"></icc-icon>{{ 'INTERFACE|Wybrany' | translate }}</button>

            <button
                *ngIf="hasAccessTo.editPosition && !b2cForm && !isComplaintAuthorCompany"
                iccButton
                (click)="editPosition()"
                appearance="outline"
            >
                {{ 'COMPLAINT|Edytuj usterkę' | translate }}<icc-icon name="edit"></icc-icon>
            </button>

            <div class="divider"></div>

            <button
                iccButton
                type="button"
                (click)="switchShowDetails(!showDetails)"
                [title]="'INTERFACE|Szczegóły' | translate"
                appearance="outline"
                class="details-button"
            >
                <icc-icon
                    *ngIf="showDetails"
                    name="compress"
                ></icc-icon>

                <icc-icon
                    *ngIf="!showDetails"
                    name="expand"
                ></icc-icon>

            </button>

        </div>
    </div>
</div>

<div
    class="document-position-details"
    *ngIf="showDetails"
>

    <div
        class="flex-col image"
    >
        <div *ngIf="getAttachment('closeUpPhoto')" class="attachment-container">
            <a [href]="'/complaint_attachments/' + getAttachment('closeUpPhoto')?.uuid" target="_blank">
                <img
                    [src]="getAttachmentImg(getAttachment('closeUpPhoto')?.uuid)"
                    [alt]="getAttachment('closeUpPhoto')?.name"
                >
            </a>
            <span class="attachment-text" style="font-weight: 500">{{ 'COMPLAINT|Zdjęcie usterki z bliska' | translate | uppercase}}</span>
        </div>
        <div *ngIf="getAttachment('wholeProductPhoto')" class="attachment-container">
            <a [href]="'/complaint_attachments/' + getAttachment('wholeProductPhoto')?.uuid" target="_blank">
                <img
                    [src]="getAttachmentImg(getAttachment('wholeProductPhoto')?.uuid)"
                    [alt]="getAttachment('wholeProductPhoto')?.name"
                >
            </a>
            <span class="attachment-text" style="font-weight: 500">{{ 'COMPLAINT|Zdjęcie usterki na całym produkcie' | translate | uppercase}}</span>
        </div>

    </div>

    <div
        class="details"
    >
        <div class="position-configuration">
            <div class="details-card">
                <ng-container *ngIf="position.defectDate">
                    <div class="details-card-container">
                        <span class="details-label">{{ 'COMPLAINT|Data zauważenia usterki' | translate }}:</span> <span class="details-value">{{position.defectDate | date: 'shortDate'}}</span><br>
                    </div>
                </ng-container>
                <ng-container *ngIf="position.serialNumber">
                    <div class="details-card-container">
                        <span class="details-label">{{ 'COMPLAINT|Nr seryjny produktu' | translate }}:</span> <span class="details-value">{{position.serialNumber}}</span><br>
                    </div>
                </ng-container>
                <ng-container *ngIf="position.orderNumber">
                    <div class="details-card-container">
                        <span class="details-label">{{ 'COMPLAINT|Nr zamówienia' | translate }}:</span> <span class="details-value">{{position.orderNumber}}</span><br>
                    </div>
                </ng-container>
                <ng-container *ngIf="position.orderPositionNumber">
                    <div class="details-card-container">
                        <span class="details-label">{{ 'COMPLAINT|Nr pozycji zamówienia' | translate }}:</span> <span class="details-value">{{position.orderPositionNumber}}</span><br>
                    </div>
                </ng-container>
                <ng-container *ngIf="position.invoiceNumber">
                    <div class="details-card-container">
                        <span class="details-label">{{ 'COMPLAINT|Nr faktury' | translate }}:</span> <span class="details-value">{{position.invoiceNumber}}</span><br>
                    </div>
                </ng-container>
                <ng-container *ngIf="position.complaintProductType">
                    <div class="details-card-container">
                        <span class="details-label">{{ 'COMPLAINT|Typ produktu' | translate }}:</span> <span class="details-value">{{getTranslatedProductType()}}</span><br>
                    </div>
                </ng-container>
            </div>
            <div class="details-card" *ngIf="positionTitle.length > 1">
                <div class="details-card-header">{{ 'COMPLAINT|Miejsce wystąpienia usterki:' | translate }}</div>
                <div class="details-card-body" *ngIf="positionTitle.length > 1">
                    <ul>
                        <li>
                            <span class="details-label">{{position.configuration.name}}</span>
                            <span class="details-value" *ngIf="positionTitle.length > 2">:
                                <ng-container *ngFor="let defectPlace of positionTitle | slice: 2; let i = index">
                                    {{defectPlace}}
                                    <ng-container *ngIf="i < ((positionTitle | slice: 2).length - 1)"> > </ng-container>
                                </ng-container>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="details-card position-description">
                <div class="details-card-header">{{ 'COMPLAINT|Opis usterki:' | translate }}</div>
                <div class="details-card-body">
                    <p class="document-description">
                        <span class="commentPre">{{ position.description }}</span>
                    </p>
                </div>
            </div>

            <div class="details-card position-attachments" *ngIf="getAttachment('additionalPhoto') || getAttachment('attachment')">
                <div class="details-card-header">{{ 'COMPLAINT|Dodatkowe materiały' | translate }}</div>
                <div class="details-card-body additional-attachments">
                    <div class="additional-attachment" *ngFor="let additionalAttachment of getAdditionalPhotosAndAttachments(); index as i">
                        <icc-icon [name]="getIconName(getAdditionalAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name)" [style]="{color: getIconColor(getAdditionalAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name)}"></icc-icon>
                        <div class="filename">
                            <a
                                *ngIf="getAdditionalAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name"
                                [title]="getAdditionalAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name"
                                [href]="'/complaint_attachments/' + additionalAttachment.uuid"
                                [download]="additionalAttachment.name"
                            >
                                {{ getAdditionalAttachment(additionalAttachment.attachmentType, additionalAttachment.uuid)?.name }}
                            </a>
                        </div>
                        <div class="description">
                            <ng-container *ngIf="additionalAttachment.attachmentType === 'distributorOrderFile'">
                                {{ 'COMPLAINT|Zamówienie pierwotne' | translate }}
                            </ng-container>
                            <ng-container *ngIf="additionalAttachment.attachmentType !== 'distributorOrderFile' && additionalAttachment.description">
                                <ng-container *ngIf="additionalAttachment.attachmentType === 'attachment'">
                                    {{ 'COMPLAINT|Załącznik #{no}' | translate: {no: (i + 1)} }} - {{ additionalAttachment.description }}
                                </ng-container>
                                <ng-container *ngIf="additionalAttachment.attachmentType !== 'attachment'">
                                    {{ 'COMPLAINT|Zdjęcie #{no}' | translate: {no: (i + 1)} }} - {{ additionalAttachment.description }}
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!b2cForm" class="details-card">
                <div class="details-card-header">{{ 'COMPLAINT|Informacja o sposobie obsługi usterki' | translate }}</div>
                <div class="details-card-body" *ngIf="!editDefectMaintenance">
                    <div class="details-card-body-description" *ngIf="data">
                        {{  getMaintenanceInstructionById(+position.defectMaintenance) }}
                    </div>
                    <button *ngIf="!preview && !position.defectMaintenance && hasAccessTo.editPosition && !isComplaintAuthorCompany" class="details-card-body-button" iccButton appearance="outline" (click)="editDefectMaintenance = true">
                        {{ 'COMPLAINT|Wprowadź informację' | translate }}  <icc-icon name="add"></icc-icon>
                    </button>
                    <icc-icon *ngIf="!preview && position.defectMaintenance && hasAccessTo.editPosition && !isComplaintAuthorCompany" class="details-card-body-button" name="edit" (click)="editDefectMaintenance = true"></icc-icon>
                </div>
                <div class="details-card-body" *ngIf="editDefectMaintenance">
                    <div class="details-card-body-description">
                        <ng-select
                            autocomplete="off"
                            [(ngModel)]="defectMaintenance"
                            [ngModelOptions]="{standalone: true}"
                            [virtualScroll]="true"
                            [searchable]="true"
                            [notFoundText]="'INTERFACE|Brak wyników' | translate"
                        >
                            <ng-option *ngFor="let defectMaintenance of data.defectMaintenances" [value]="defectMaintenance.id">
                                {{ defectMaintenance.maintenanceInstruction }}
                            </ng-option>
                        </ng-select>
                        <div class="action-buttons">
                            <button iccButton appearance="primary" (click)="changeDefectMaintenance(defectMaintenance); editDefectMaintenance = false">
                                {{ 'INTERFACE|Zapisz' | translate }}
                            </button>
                            <button iccButton appearance="secondary" (click)="editDefectMaintenance = false">
                                {{ 'INTERFACE|Anuluj' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    </div>

</div>



